
<template>
  <div>
    <div v-show="!noCauseDialog">
      <Navbar
        :appTitle="$route.query.type == 'edit' ? '编辑报工' : '报检'"
        @ClickRight="$router.push('/application')"
      />
      <div
        class="search-content wrap-apply"
        :style="{
          top: GLOBAL.currentEnvironment ? '0' : '',
          paddingBottom: GLOBAL.currentEnvironment ? '132px' : '',
        }"
      >
        <van-cell-group style="margin-top: 20px">
          <p class="label required FormTit"><span></span>工单编号</p>
          <scanInput
            v-if="showScan"
            ref="scanInput"
            :columns="orderList"
            placeholder="请选择/扫码"
            @changeScan="changeScan"
          />
          <van-field
            v-else
            readonly
            v-model="buildForm.orderCode"
            placeholder="请选择/扫码"
          />
          <div class="bottomLine"></div>
        </van-cell-group>
        <van-cell-group>
          <p class="label FormTit"><span></span>生产物品</p>
          <van-field
            type="textarea"
            readonly
            v-model="buildForm.goodsName"
            placeholder="根据工单带入"
          />
          <div class="bottomLine"></div>
        </van-cell-group>
        <van-cell-group>
          <p class="label FormTit"><span></span>计划生产数量</p>
          <van-field
            readonly
            v-model="buildForm.planProduceNum"
            placeholder="根据工单带入"
          />
          <div class="bottomLine" style="margin-top: 2px"></div>
        </van-cell-group>

        <!-- <van-cell-group>
          <p class="label FormTit"><span></span>项目名称</p>
          <van-field
            readonly
            v-model="buildForm.projectName"
            placeholder="根据工单带入"
          />
          <div class="bottomLine"></div>
        </van-cell-group> -->
        <van-cell-group>
          <p class="label required FormTit"><span></span>报检数</p>
          <van-field
          type="number"
            v-model="buildForm.uninspectionNumber"
            placeholder="请输入"
          />
          <div class="bottomLine"></div>
        </van-cell-group>
        <van-cell-group>
          <p class="label FormTit"><span></span>报检描述</p>
          <van-field
            type="textarea"
            maxlength="500"
            v-model="buildForm.description"
            placeholder="请输入"
          />
          <div class="bottomLine"></div>
        </van-cell-group>

        <van-cell-group>
          <p class="label FormTit"><span></span>附件</p>
          <file-selector
            ref="fileSelect"
            :maxCount="6"
            :fileIds="buildForm.attachments"
            @fileChange="fileChange"
          ></file-selector>
        </van-cell-group>

        <div class="jiange-line"></div>

        <div class="search-bottoms">
          <van-button
            @click="back"
            block
            color="#f6f6f6"
            :loading="subLoading"
            loading-text="加载中..."
          >
            <div style="color: #333; font-weight: 400">取消</div>
          </van-button>
          <van-button
            style="margin-left: 10px"
            @click="btnConfirm(null, true)"
            block
            color="#1890ff"
            :loading="subLoading"
            loading-text="加载中..."
          >
            <div style="color: #fff">
              {{ subBtnText }}
            </div>
          </van-button>
        </div>
      </div>

      <!--选择报工时间 -->
      <van-popup v-model="timePickShow" position="bottom">
        <van-datetime-picker
          @confirm="confirmPick"
          v-model="happenTime"
          @cancel="cancelPick"
          type="datetime"
          title="报工时间"
          :formatter="formatter"
        />
      </van-popup>

      <!--不合格项组件-->
      <unqualified-item-dialog
        ref="unqualifiedItemDialog"
        :unqualifiedItemList="unqualifiedItemList"
        @getValue="getValue($event)"
      ></unqualified-item-dialog>
      <!-- 操作按钮弹窗-->
      <van-popup v-model="showPicker" round position="bottom">
        <van-picker
          show-toolbar
          :columns="processList"
          @cancel="showPicker = false"
          @confirm="onConfirm"
          value-key="key"
        />
      </van-popup>

      <!--操作人组件-->
      <contact-pickers
        :visible="userSelectVisible"
        @closePicker="userSelectVisible = false"
        @confirm="selectOperator"
      >
      </contact-pickers>
    </div>

    <PDAsao ref="pda" @changeScan="changeScan1" />
  </div>
</template>

<script>
import moment from "moment";
import Navbar from "@/components/navBar/navBar_right";
import scanInput from "@/components/scanCode/scanInput";
import scanInputContact from "@/components/scanCode/scanInputContact";
import upload from "@/components/upload/upload";
import VanFieldSelectPicker from "@/components/ActionSheet/VanFieldSelectPicker";
import fileSelector from "@/components/fileSelector.vue";
import Examine from "@/components/examine";
import {
  processByBatchId,
  productionTaskProcessMessage,
  workOrderDetailQueryById,
  workOrderList
} from "@/api/productionApply";
import ContactPickers from "@/components/choiceuse/ContactPickers.vue";
import unqualifiedItemDialog from "@/views/workManagement/components/unqualifiedItemDialog.vue";
import { Tip as Tips } from "@/utils";
import { postAction } from "@/api/manage";
import PDAsao from "./components/PDAsao.vue";
import FileSelector from "../../../components/fileSelector.vue";
export default {
  name: "newOutsourcingReport",
  components: {
    PDAsao,
    unqualifiedItemDialog,
    ContactPickers,
    fileSelector,
    upload,
    VanFieldSelectPicker,
    Navbar,
    scanInput,
    Examine,
    scanInputContact,
    FileSelector,
  },
  data() {
    return {
      subBtnText: "提交",
      subLoading: false,
      userIdList: [],
      realnameList: [],
      userIdScanList: [],
      detailInfo: {},
      sequentially: false,
      formTypeExtendedFields: [],
      happenTime: new Date(),
      timePickShow: false,
      noCauseDialog: false,
      unqualifiedItemDialog: false,
      showPicker: false,
      userSelectVisible: false, // 操作人选择组件
      buildForm: {
        unqualifiedNum: 0,
        uninspectionNumber: 0,
        qualifiedNum: "",
        extDataJson: {},
        userId: "",
      },
      unqualifiedItemModal: false, // 填写不合格项数量
      unqualifiedItemList: [], // 不合格项列表
      orderList: [],
      columns: [],
      processList: [],
      showScan: false,
      availableUninspectionNumber:0
    };
  },
  beforeRouteLeave(to, from, next) {
    if (this.showPeopleSlect) {
      this.$refs.examine.closePicker();
      next(false);
    } else {
      next();
    }
  },
  async created() {
    // 获取工单编号
    this.getInitData()
    const id = this.$route.query.id;
    const orderCode = this.$route.query.orderCode;
    this.buildForm.orderId = id;
    this.buildForm.orderCode = orderCode

    workOrderDetailQueryById({ id })
      .then((res) => {
        if (res.code == 200) {
          this.availableUninspectionNumber = res.result.availableUninspectionNumber
          this.buildForm.planProduceNum = res.result.planProduceNum;
          this.buildForm.projectName = res.result.projectName || '-';
          this.buildForm.goodsName =
            res.result.serialNumber +
            " | " +
            res.result.serialName +
            " | " +
            (res.result.serialSpecifications || "");
          this.showScan = true;
          this.buildForm.uninspectionNumber = res.result.availableUninspectionNumber
          this.$nextTick(e => {
            this.$refs.scanInput.formData.key = orderCode; //回显工单
            this.$refs.scanInput.formData.value = id; //回显工单
          })
        }
      });
  },

  methods: {
    // 红外扫码
    changeScan1(v, flag) {
      let EntityType = v.EntityType;
      let userid = v.userid;
      if (v.EntityType === "workOrder") {
        // 扫码之后清空下方数据
        this.processList = []; // 工单编号有变化时清空工序字段的内容
        this.buildForm.taskId = undefined;
        this.buildForm.qualifiedNum = 0;
        //工单码
        workOrderDetailQueryById({ id: v.id }).then((res) => {
          if (res.code == 200) {
            // 判断工单是否为“生产中”状态
            if (res.result.orderStatus == 1) {
              this.buildForm.planProduceNum = res.result.planProduceNum;
              this.buildForm.projectName = res.result.projectName;
              this.buildForm.orderCode = res.result.orderCode;
              this.buildForm.taskId = res.result.taskId;
              this.buildForm.goodsName =
                res.result.serialNumber +
                "|" +
                res.result.serialName +
                "|" +
                (res.result.serialSpecifications || "");
              this.buildForm.uninspectionNumber = res.result.availableUninspectionNumber
              this.$refs.scanInput.formData.key = res.result.orderCode; //回显工单
              this.$refs.scanInput.formData.value = res.result.taskId; //回显工单
              this.$forceUpdate();
              // workOrderList({
              //   pageNo: 1,
              //   pageSize: 9999,
              //   orderCode: this.buildForm.orderCode,
              // }).then((res) => {
              //   if (res.code == 200) {
              //     this.buildForm.goodsName =
              //       res.result.records[0].serialNumber +
              //       " | " +
              //       res.result.records[0].serialName +
              //       " | " +
              //       (res.result.records[0].serialSpecifications || "");
              //     this.processList =
              //       res.result.records[0].produceOrderTaskVo.map((item) => {
              //         return {
              //           label: item.processesName,
              //           key: item.processesName,
              //           value: item.processesId,
              //           taskId: item.taskId,
              //         };
              //       });
              //   }
              // });
            } else {
              this.buildForm.orderCode = "";
              this.$toast("工单状态不正确");
            }
          } else {
            this.$toast(res.message);
          }
        });
      } 
      // else if (EntityType === "productTask") {
      //   //任务二维码
      //   // 判断当前生产任务对应的生产工单状态是否为“生产中”
      //   // 若判断为是，则把工单编号、工序进行回显，且把对应的可报工数回显到合格数字段。若判断不是“生产中”状态，则toast提示“工单状态不正确”；
      //   this.processList = []; // 工单编号有变化时清空工序字段的内容
      //   this.buildForm.taskId = undefined;
      //   this.buildForm.qualifiedNum = 0;
      //   produceOrderReportWorkWorkbenchProduce({
      //     id: v.id,
      //   }).then((res) => {
      //     if (res.code == 200) {
      //       console.log("res.result", res.result);
      //       // 判断工单是否为“生产中”状态
      //       // 若判断为是，则把工单编号回显到当前表单。若判断不是“生产中”状态，则toast提示“工单状态不正确”；
      //       if (res.result.orderStatus == 1) {
      //         this.buildForm.orderCode = res.result.orderCode;
      //         this.buildForm.taskId = res.result.id;
      //         // this.$toast(res.result.id)
      //         this.$refs.scanInput.formData.key = res.result.orderCode; //回显工单
      //         this.$refs.scanInput.formData.value = res.result.id; //回显工单
      //         workOrderList({
      //           pageNo: 1,
      //           pageSize: 9999,
      //           orderCode: this.buildForm.orderCode,
      //         }).then((res) => {
      //           if (res.code == 200) {
      //             this.buildForm.goodsName =
      //               res.result.records[0].serialNumber +
      //               " | " +
      //               res.result.records[0].serialName +
      //               " | " +
      //               (res.result.records[0].serialSpecifications || "");

      //             this.processList =
      //               res.result.records[0].produceOrderTaskVo.map((item) => {
      //                 return {
      //                   label: item.processesName,
      //                   key: item.processesName,
      //                   value: item.processesId,
      //                   taskId: item.taskId,
      //                 };
      //               });
      //           }
      //         });
      //       } else {
      //         this.buildForm.orderCode = "";
      //         this.$toast("工单状态不正确");
      //       }
      //     } else {
      //       this.$toast(res.message);
      //     }
      //   });
      // } 
      else if (v >= 0) {
        //数字条码
        // 若扫到数字条码，则把数字条码回显到合格数框，多次扫数字条码则自动拼接。
        // this.$toast(v)
        if (this.buildForm.uninspectionNumber > 0) {
          let addStr = v + "";
          this.buildForm.uninspectionNumber = this.buildForm.uninspectionNumber + addStr;
        } else {
          this.buildForm.uninspectionNumber = v + "";
        }
        this.buildForm.uninspectionNumber = this.buildForm.uninspectionNumber.substring(
          0,
          9
        );
      } 
      // else if (EntityType === "printTask" && userid) {
      //   //用户二维码
      //   // 扫用户二维码，则把用户回显到操作人字段，扫一个用户二维码则回显一个，多个姓名之间用“，”隔开。
      //   // 若扫到重复的用户二维码则toast提示“该用户已存在”。
      //   let users = this.buildForm.userId.split(",");
      //   if (!users.includes(userid) && this.buildForm.userId) {
      //     // this.buildForm.userId = this.buildForm.userId + ',' + v.userid
      //     this.$refs.scanInput3.formData.key = userid;
      //     this.$refs.scanInput3.formData.value = userid;
      //     getAction("/sys/user/queryById", { id: userid }).then((res) => {
      //       if (res.code == 200) {
      //         this.realnameList.push(res.result.realname);
      //         this.userIdList.push(res.result.id);
      //         this.buildForm.userIdText = this.realnameList.join(",");
      //         this.buildForm.userId = this.userIdList.join(",");
      //         this.$forceUpdate();
      //       }
      //     });
      //   } else if (!users.includes(userid) && !this.buildForm.userId) {
      //     // this.buildForm.userId = v.userid
      //     getAction("/sys/user/queryById", { id: userid }).then((res) => {
      //       if (res.code == 200) {
      //         this.realnameList.push(res.result.realname);
      //         this.userIdList.push(res.result.id);
      //         this.buildForm.userIdText = this.realnameList.join(",");
      //         this.buildForm.userId = this.userIdList.join(",");
      //         this.$forceUpdate();
      //       }
      //     });
      //   } else {
      //     this.$toast("该用户已存在");
      //   }
      // } 
      else if (!EntityType) {
        Tips.error("请扫正确的二维码");
      }
    },
    onInput(event, digitCount, fieldType) {
      let value = event + "";
      if (fieldType == 3 || fieldType == 4) {
        // 截断小数点后超过4位的部分
        if (value.includes(".")) {
          let parts = value.split(".");
          if (parts[1].length > 4) {
            value = parts[0] + "." + parts[1].substring(0, 4);
          }
        } else {
          value = event;
        }
        // 最大可以输入值
        if (digitCount <= 0) {
          throw new Error("Digit count must be a positive integer.");
        }
        let maxValue = Math.pow(10, digitCount) - 1 + 0.9999;
        if (value > maxValue) {
          value = maxValue;
          this.$toast("输入值超过允许输入最大值，已取值最大值");
        }
      }

      return value;
    },
    clearNoNumTwo(value, type, length) {
      if (type != 3 && type != 4) {
        return value;
      } else {
        return value.replace(/[^\d]/g, "");
      }
    },
    formatter(type, val) {
      console.log(type);
      if (type === "year") {
        return val + "年";
      }
      if (type === "month") {
        return val + "月";
      }
      if (type === "day") {
        return val + "日";
      }
      if (type === "hour") {
        return val + "时";
      }
      if (type === "minute") {
        return val + "分";
      }
      if (type === "second") {
        return val + "秒";
      }

      return val;
    },

    // 确定选择时间
    confirmPick(date) {
      this.buildForm.reportTime = moment(date).format("YYYY-MM-DD HH:mm:ss");
      this.timePickShow = false;
    },
    // 取消选择时间
    cancelPick() {
      this.timePickShow = false;
    },
    noCauseConfirm(list, total) {
      this.noCauseDialog = false;
      this.buildForm.unqualifiedNum = total;
      this.buildForm.unqualifiedNotes = list
        .map((item) => item.nonconformityDescribe + ":" + item.num)
        .join(",");
      this.buildForm.produceOrderReportWorkNonconformityDetail = list.map(
        (item) => {
          return {
            nonconformityNum: item.num,
            nonconformityId: item.id,
          };
        }
      );
      this.$forceUpdate();
    },
    noCauseCancel() {
      this.noCauseDialog = false;
    },
    // 根据批次id获取对应批次下的工序
    getBatchList(id) {
      processByBatchId({ id }).then((res) => {
        let processList = res.result;
        //   找到sort最大值的工序，根据工序id查询对应工单的信息回填
        // 使用reduce方法查找最大排序值的项
        let maxItem = processList.reduce(function (prev, current) {
          return prev.sort > current.sort ? prev : current;
        });
        console.log(maxItem);
        this.buildForm.processName = maxItem.processesName;
        this.getOrderInfo(maxItem.id);
      });
    },
    getOrderInfo(id) {
      productionTaskProcessMessage({ id }).then((rst) => {
        console.log(rst);
        this.buildForm.orderId = rst.result.orderId;
        this.buildForm.orderCode = rst.result.orderCode;
        this.buildForm.goodsName =
          rst.result.goodsName + "-" + rst.result.goodsCode;
        this.buildForm.orderCode = rst.result.orderCode;
        this.buildForm.processName = rst.result.processesCode;
        this.buildForm.goodsName =
          rst.result.goodsName + "-" + rst.result.goodsCode;
        this.buildForm.orderId = rst.result.id;
        this.buildForm.goodsId = rst.result.goodsId;
        this.buildForm.goodsBasicUnit = rst.result.goodsBasicUnit;
        this.processList = rst.result.processList.map((item) => {
          return {
            label: item.processesName,
            key: item.processesName,
            value: item.id,
          };
        });
      });
    },
    fillUnqualifiedItem() {
      this.noCauseDialog = true;
      this.$refs.noCaseComp.initData(
        this.detailInfo.produceOrderReportWorkNonconformityDetailVoList
      );
    },
    getValue(query) {
      this.buildForm.unqualifiedQuantityNum = query.sum;
      this.buildForm.unqualifiedReason = query.sum2;
      this.buildForm.unqualifiedDtos = query.unqualifiedList.map((item) => {
        return {
          id: item.id,
          num: item.num,
        };
      });
    },
    onConfirm(a, b) {
      console.log(a, b, "ab");
      if (typeof a == "undefined") {
        this.showPicker = false;
        return;
      }
      this.buildForm.processId = a.value;
      this.buildForm.processName = a.key;
      this.showPicker = false;
    },
    handleChooseOperator(index, item) {
      this.currentIndex = index;
      this.userSelectVisible = true;
    },
    confirmOperator(v) {
      console.log(v);
      if (!v) {
        console.log(v);
        this.buildForm.userId = "";
        this.buildForm.userIdText = "";
        this.$forceUpdate();
      } else {
        console.log(2);
        this.buildForm.userId = v;
        this.buildForm.userIdText = v.join(",");
      }
    },

    selectOperator(val, selectedList) {
      console.log(val, selectedList);
      this.userSelectVisible = false;
      if (selectedList.length) {
        this.buildForm.userId = val;
        this.buildForm.userIdText = selectedList
          .map((item) => item.realname)
          .join(",");
      } else {
        this.buildForm.userId = "";
        this.buildForm.userIdText = "";
      }
    },
    //页面加载请求数据
    async getInitData() {
      const WorkOrderRes = await workOrderList({
        orderStatuss:1,
        pageNo: 1,
        pageSize: 100000,
      });
      if (WorkOrderRes && WorkOrderRes.code == 200) {
        this.orderList = WorkOrderRes.result.records.map((item) => {
          return {
            key: item.orderCode,
            value: item.id,
          };
        });
      }
    },

    changeScan(v, opratorType) {
      console.log(v, opratorType, "获取扫码组件数据", this.buildForm.orderId);
      //value是下拉选择后值,code是扫码获得的值，根据qrcode判断是否隐藏当前页面只显示相机页
      if (opratorType == "select" && this.buildForm.orderId != v.value) {
        this.buildForm.orderId = v.value;
        this.buildForm.orderCode = v.key || "-";

        // this.$refs.scanInput2.formData.value = undefined;
        // this.$refs.scanInput2.formData.key = undefined;
        this.buildForm.processesId = "";
        this.buildForm.processesName = "";
        this.buildForm.taskId = "";

        workOrderList({
          pageNo: 1,
          pageSize: 9999,
          orderCode: this.buildForm.orderCode,
        }).then((res) => {
          if (res.code == 200) {
            this.buildForm.planProduceNum =
              res.result.records[0].planProduceNum;
            this.buildForm.projectName = res.result.records[0].projectName;

            this.buildForm.goodsName =
              res.result.records[0].serialNumber +
              " | " +
              res.result.records[0].serialName +
              " | " +
              (res.result.records[0].serialSpecifications || "");
              this.buildForm.uninspectionNumber = res.result.availableUninspectionNumber
            this.processList = res.result.records[0].produceOrderTaskVo.map(
              (item) => {
                return {
                  label: item.processesName,
                  key: item.processesName,
                  value: item.processesId,
                  taskId: item.taskId,
                };
              }
            );
          }
        });
      }
      if (opratorType == "scan") {
        console.log(v.code);
        if (v.code.EntityType !== "workOrder") {
          this.$toast("请扫正确二维码");
          return;
        }
        let obj = {
          id: v.code.id, //
        };
        workOrderList(obj).then((res) => {
          if (res.code == 200) {
            if (res.result.records[0].orderStatus != 1) {
              this.$toast("工单状态不正确");
              return;
            }
            this.buildForm.orderId = res.result.records[0].orderId;
            this.buildForm.orderCode = res.result.records[0].orderCode;

            this.$refs.scanInput.formData.value = undefined;
            this.$refs.scanInput.formData.key = undefined;

            this.$refs.scanInput.formData.value = res.result.records[0].orderId;
            this.$refs.scanInput.formData.key = res.result.records[0].orderCode;
            this.$refs.scanInput.showPicker = true;
            this.$refs.scanInput.showPicker = false;
            this.buildForm.goodsName =
              res.result.records[0].serialNumber +
              " | " +
              res.result.records[0].serialName +
              " | " +
              (res.result.records[0].serialSpecifications || "");
            this.buildForm.uninspectionNumber = res.result.availableUninspectionNumber
            this.processList = res.result.records[0].produceOrderTaskVo.map(
              (item) => {
                return {
                  label: item.processesName,
                  key: item.processesName,
                  value: item.processesId,
                  taskId: item.taskId,
                };
              }
            );
          }
        });
      }
    },

    fileChange(ids) {
      this.buildForm.attachments = ids;
      console.log("父组件" + ids); //你要保存的fileids
    },
    // 只能输入大于0的数字且不能大于计划生产数量，最多16位，其中小数点后4位
    validateInput(value, type) {
      if (!value) {
        this.$toast(type + "必填");
        return true;
      }
      // console.log('===============>',value,type)
      // 去除非法字符
      // value = value.replace(/[^\d.]/g, '');
      if (value.length > 1 && value.startsWith("0") && value !== "0") {
        this.$toast(type + "不能以0开头");
        return true;
      }
      // 检查小数点数量
      if ((value.match(/\./g) || []).length > 1) {
        this.isInvalid = true;
        this.$toast(type + "只能输入一个或零个小数点");
        return true;
      }

      // 检查小数部分长度
      if (value.includes(".") && value.split('.')[1] && value.split('.')[1].length > 4) {
        this.isInvalid = true;
        this.$toast(type + "小数部分不能超过4位");
        // this.errorMessage = '小数部分不能超过4位';
        return true;
      }

      // 检查总长度
      if (value.length > 16) {
        this.isInvalid = true;
        this.$toast(type + "总长度不能超过16位");
        return true;
      }

      // 验证通过
      return false;
    },
    back(){
      this.$router.go(-1);
    },
    // 提交
    btnConfirm(val, back) {
      if (!this.buildForm.orderCode) {
        this.$toast("请选择工单编号");
        return;
      }

      if (!this.buildForm.uninspectionNumber) {
        this.$toast("请输入报检数");
        return;
      }

      if (this.buildForm.uninspectionNumber < 0) {
        this.$toast("报检数不小于0");
        return;
      }
      if (this.validateInput(this.buildForm.uninspectionNumber, "报检数")) {
        return;
      }
      if (this.buildForm.uninspectionNumber > this.availableUninspectionNumber) {
        this.$toast("报检数不能大于可报检数");
        return;
      }

      this.handleSubmit(back);
    },
    handleSubmit(back) {
      let params = {
        ...this.buildForm,
      };

      if (this.$route.query.type == "add") {
        // x新建
        postAction("/jksaas-produce/produce/quality/inspectionTask/add", {
          ...params,
        })
          .then((res) => {
            if (res.success) {
              this.$toast("新建成功");
              this.$router.back();
            } else {
              this.$toast(res.message);
            }
          })
          .finally(() => {
            this.subLoading = false;
          });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/theme.scss";

.jiange-line {
  height: 20px;
  background-color: #f5f5f5;
}

.required span::after {
  left: -20px;
  top: 3px;
}

.search-content {
  position: fixed;
  top: 110px;
  width: 100%;
  height: calc(100vh - 180px);
  background: #fff;
  overflow: scroll;
  z-index: 99;
  padding-bottom: 50px;

  .formgroup {
    background: #ffffff;
    // padding: 0 0.16rem;
    margin-top: 20px;
    margin-bottom: 40px;
    padding-top: 20px;

    .title {
      width: 116px;
      height: 28px;
      font-size: 30px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #191f25;
      line-height: 10px;
      margin-left: 32px;
    }
  }
}

.bottomLine {
  height: 2px;
  background-color: #f0f0f0;
  margin: 0 32px;
}

.otherText {
  padding-bottom: 32px;
  font-size: 32px;
  font-weight: bold;
  color: #191f25;
}

.haveUnitBox {
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-sizing: border-box;
  padding-right: 32px;

  /deep/ .van-cell {
    padding-right: 0;
    width: 520px;
  }

  /deep/ .van-field__control {
    max-width: 600px;
  }
}

/deep/ .van-nav-bar {
  z-index: 99;
}

.search-bottoms {
  width: 100%;
  height: 100px;
  background: #ffffff;
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: fixed;
  bottom: 0px;
  padding: 0 22px;
  box-sizing: border-box;
  font-size: 32px;
  font-weight: 500;
  z-index: 9;

  .btncancel {
    flex: 1;
    background: #f6f6f6;
    border: 2px solid rgba(25, 31, 37, 0.12);
    box-sizing: border-box;
    height: 78px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 6px;
    margin-right: 22px;
    color: #191f25;
  }

  .btnconfirm {
    flex: 1;
    background: #1890ff;
    box-sizing: border-box;
    height: 79px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 6px;
    color: #ffffff;
  }
}
</style>